import React from 'react';
import { Link } from 'react-router-dom';
import "../../styles/LandingPasswordSaved.css";

export default function LandingNewPassword({history}) {


    return (
        <div className="LandingPasswordSaved form">
            <h1>New Password Saved!</h1>
            <div>
                <Link to='/login'>Go To Login!</Link>
            </div>
        </div>
    )
}